import { useRef, useEffect, useState } from "react";
import { ForwardersActions } from "forwarder/stores/ForwardersStore";
import { ForwarderInputsActions } from "forwarder/stores/ForwarderInputsStore";
const getCurrentForwarder = (forwarders, forwarderNodeId) => forwarders.find((value) => value.node_id === forwarderNodeId);
const getCurrentInput = (inputs, inputId) => inputs.find((value) => value.id === inputId);
const useReceivedBy = (inputId, forwarderNodeId) => {
  const [forwarder, setForwarder] = useState();
  const [input, setInput] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const fetchForwarderPromise = useRef();
  const fetchInputPromise = useRef();
  useEffect(() => {
    const fetchInputs = (inputProfileId) => {
      if (fetchInputPromise.current) {
        return;
      }
      fetchInputPromise.current = ForwarderInputsActions.listAll({ inputProfileId }).then((response) => {
        const currentInput = getCurrentInput(response.forwarder_inputs, inputId);
        setInput(currentInput);
        return response;
      }).finally(() => {
        fetchInputPromise.current = void 0;
        setIsLoading(false);
      });
    };
    const fetchForwarders = () => {
      if (fetchForwarderPromise.current) {
        return;
      }
      setIsLoading(true);
      fetchForwarderPromise.current = ForwardersActions.listAll().then((response) => {
        const currentForwarder = getCurrentForwarder(response.forwarders, forwarderNodeId);
        setForwarder(currentForwarder);
        if (currentForwarder == null ? void 0 : currentForwarder.input_profile_id) {
          fetchInputs(currentForwarder.input_profile_id);
        }
        return response;
      }).finally(() => {
        fetchForwarderPromise.current = void 0;
      });
    };
    fetchForwarders();
    return () => {
      fetchForwarderPromise.current = void 0;
      setIsLoading(false);
    };
  }, [forwarderNodeId, inputId]);
  return { isLoading, forwarder, input };
};
export default useReceivedBy;
